import styled from "styled-components";

const SuccessModalContainer = styled.div.attrs({
  className:
    "w-full flex flex-col justify-center items-center text-center p-6 gap-5",
})``;

const SuccessTitle = styled.h1.attrs({
  className: "font-bold text-xl color-[#444444]",
})``;

const SuccessMessage = styled.p.attrs({
  className: "w-80",
})``;

const CenterStandar = styled.p.attrs({
  className: "flex w-full flex-col justify-center",
})``;

export default {
  SuccessModalContainer,
  SuccessTitle,
  SuccessMessage,
  CenterStandar,
};
